import defaultState from './state';

export default {
  setCurrentStepId(state, stepId) {
    state.currentStep.id = stepId;
  },
  setCurrentStepValid(state, valid) {
    state.currentStep.valid = valid;
  },
  setMode(state, mode) {
    state.mode = mode;
  },
  setForm(state, form) {
    state.form = form;
  },
  setType(state, type) {
    state.type = type;
  },
  setOpened(state, opened) {
    state.opened = opened;
  },
  setStepsState(state, stepsState) {
    state.stepsState = stepsState;
  },
  updateStepState(state, { stepId, stepState }) {
    Object.assign(state.stepsState, {
      [stepId]: stepState,
    });
  },
  setStepsIds(state, stepsIds) {
    state.stepsIds = stepsIds;
  },
  setFiles(state, files) {
    state.files = files;
  },
  updateFile(state, file) {
    const index = state.files.findIndex(x => x.id === file.id);

    if (index !== -1) {
      state.files = Object.assign([], state.files, { [index]: file });
    }
  },
  removeFile(state, fileId) {
    state.files = state.files.filter(file => file.id !== fileId);
  },
  reset(state) {
    const files = [...state.files];
    Object.assign(state, defaultState(), { files });
  },
};
